export default __webpack_public_path__ + "images/logo-events-en.svg?c8f7d0acfca3e6b8c37145faa55ad771";